<!-- Old class with condition in div.modal => [class.bg-backdrop]="modal_info.type == ModalType.Confirm" -->
<div *ngIf="modal_info"
     class="modal"
     [class.bg-backdrop]="modal_info.type == ModalType.Alert"
     tabindex="-1"
     role="dialog"
     style="display:block">
  <!-- Old condition to hide or show div.modal-backdrop => *ngIf="modal_info.type != ModalType.Confirm" -->
  <div class="modal-backdrop" *ngIf="modal_info.type != ModalType.Alert" (click)="modal_info.noFn()"></div>
  <div class="modal-dialog modal-dialog-centered"
       [ngClass]="{'modal-big' : modal_info.template == ModalTemplate.InfoImagesFlex}"
       [ngStyle]="styleModal(modal_info.type)"
       role="document">
    <div class="modal-content modal-styled p-5" *ngIf="modal_info.type != ModalType.Custom"
         [ngStyle]="styleModalContent(modal_info.type)">
      <div *ngIf="modal_info.title" class="modal-header justify-center">
        <h3 class="modal-title" [innerHtml]="modal_info.title"></h3>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <p class="text-center confirm-message" [innerHtml]="modal_info.text"></p>
          </div>
        </div>
        <div class="modal-footer px-0" *ngIf="modal_info.type == ModalType.Confirm">
          <button type="button" class="btn btn-solid-grey-blue"
                  (click)="modal_info.noFn()"
                  [innerHtml]="modal_info.template == ModalTemplate.Confirmation ? global_texts.no : global_texts.cancel"></button>
          <button type="button" class="btn btn-solid-green"
                  (click)="modal_info.siFn()"
                  [innerHtml]="modal_info.template == ModalTemplate.Confirmation ? global_texts.yes : global_texts.continue"></button>
        </div>
        <div class="modal-footer px-0" *ngIf="modal_info.type == ModalType.Alert">
          <button type="button" class="btn btn-solid-green" (click)="modal_info.siFn()"
                  [innerHtml]="modal_info.template == ModalTemplate.SessionExpired ? global_texts?.modals?.expired_session?.confirm : global_texts.ok"></button>
        </div>
      </div>
    </div>

    <!-- =========================================== ModalTypes.Custom modal-custom-->
    <div class="modal-content modal-custom bg-white"
         [class.height-auto]="modal_info.template == ModalTemplate.InfoOnlyText"
         *ngIf="modal_info.type == ModalType.Custom">
      <button type="button" class="btn close" data-dismiss="modal" aria-label="Close" (click)="modal_info.noFn()">
        <span class="material-icons">close</span>
      </button>
      <h3 *ngIf="modal_info.title" class="modal-title title" [innerHtml]="modal_info.title"></h3>

      <div class="modal-body" *ngIf="modal_info.data" [class.modal-body-without-title]="!modal_info.title">

        <div class="grid-images d-flex flex-column flex-lg-row gap-3">
          <div *ngFor="let item of modal_info.data">
            <h2 *ngIf="item.title" class="text-center mb-4" [innerHtml]="item.title"></h2>
            <!-- Hidden by the moment => [class.smaller-img-desktop]="modal_info.data.length == 1"-->
            <img class="flex-fill" *ngIf="item.image" [src]="item.image" [attr.alt]="item.image">
            <h5 class="mt-4" *ngIf="item.text" [innerHtml]="item.text"></h5>

            <div *ngIf="item.asterisks" class="mt-3">
              <app-asterisks [asterisks]="item.asterisks"></app-asterisks>
            </div>

            <div *ngIf="item.small_texts" class="mt-3">
              <app-small-texts [smallTexts]="item.small_texts"></app-small-texts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
